// extracted by mini-css-extract-plugin
export default {"supplier-supplier-code-cell":"vCvElEdkG6FrY1anGBPJ","supplier-code":"GmRL35Ttykn4BiVJxD7Q"};